import { X } from "lucide-react";

export default function Modal({ open, onClose, title, children, wide, testid }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-start justify-center p-4 sm:p-8 overflow-auto no-print"
         style={{ background: "rgba(26,29,32,.4)", backdropFilter: "blur(2px)" }} onMouseDown={onClose}>
      <div
        className={`card shadow-2xl w-full ${wide ? "max-w-4xl" : "max-w-lg"} fade-up my-4`}
        onMouseDown={(e) => e.stopPropagation()}
        data-testid={testid}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#E6E1D8] sticky top-0 bg-white rounded-t-[14px]">
          <h3 className="font-display text-xl">{title}</h3>
          <button onClick={onClose} className="text-[#8C929B] hover:text-[#1A1D20]" data-testid="modal-close"><X size={20} /></button>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}
